<template>
  <div class="py-4 px-3" id="key-details-page">
    <v-row>
      <v-col cols="6" class="py-0">
        <v-card-text class="pb-0 pt-3">
          Key Code
        </v-card-text>
      </v-col>
      <v-col cols="6" class="py-0">
        <v-card-text
          class="text-subtitle-1 font-weight-medium text-right pb-0 pt-3"
          id="key-code"
        >
          {{ _data.code }}
        </v-card-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="5" class="py-0">
        <v-card-text class="pb-0 pt-1">
          Email
        </v-card-text>
      </v-col>
      <v-col cols="7" class="py-0">
        <v-card-text
          class="text-subtitle-1 font-weight-medium text-right pb-0 pt-1 text-truncate"
          id="key-email"
        >
          {{ _data.email }}
        </v-card-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="py-0">
        <v-card-text class="pb-0 pt-1">
          Phone Number
        </v-card-text>
      </v-col>
      <v-col cols="6" class="py-0">
        <v-card-text
          class="text-subtitle-1 font-weight-medium text-right pb-0 pt-1"
          id="key-phone"
        >
          {{ formatPhone(_data.phone) }}
        </v-card-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="5" class="py-0">
        <v-card-text class="pb-0 pt-1">
          Return Date
        </v-card-text>
      </v-col>
      <v-col cols="7" class="py-0">
        <v-card-text
          class="text-subtitle-1 font-weight-medium text-right pb-0 pt-1 text-truncate"
          id="key-date"
        >
          {{ returnDate }}
        </v-card-text>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="py-0">
        <v-card-text class="pb-3 pt-1">
          Created By
        </v-card-text>
      </v-col>
      <v-col cols="6" class="py-0">
        <v-card-text
          class="text-subtitle-1 font-weight-medium text-right pb-3 pt-1"
          id="key-created-by"
        >
          {{ getGroupName(_data.group_id) }}
        </v-card-text>
      </v-col>
    </v-row>
    <v-divider />
    <v-row>
      <v-col cols="5" class="py-0">
        <v-card-text class="pb-0 pt-4">
          Key Used?
        </v-card-text>
      </v-col>
      <v-col cols="7" class="py-0">
        <v-card-text
          class="text-subtitle-1 font-weight-medium text-right pb-0 pt-4 text-truncate"
          id="key-used"
        >
          {{ _data.used ? `Yes` : `No` }}
        </v-card-text>
      </v-col>
    </v-row>
    <div class="d-flex justify-center pt-8">
      <div class="d-flex flex-column">
        <v-btn
          @click="_setEdit(true)"
          width="160"
          height="40"
          class="mb-4"
          color="primary"
          id="digital-key-edit-button"
          >Edit</v-btn
        >
        <v-btn @click="goBack()" width="160" height="40" text id="key-close"
          >Close</v-btn
        >
      </div>
    </div>
    <edit-key />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import EditKey from '@/components/key-codes/EditKey';
import router from '../router';
import FormatPhone from '@/mixins/FormatPhone';

export default {
  components: {
    EditKey,
  },
  mixins: [FormatPhone],
  computed: {
    ...mapGetters({
      _data: 'digitalKeyDetails/getDetails',
      currentClient: 'account/getCurrentClient',
      _clientIsSet: 'account/getClientIsSet',
    }),
    returnDate() {
      return this._data
        ? moment(this._data.expected_return * 1000).format('MM-DD-YYYY')
        : '';
    },
  },
  methods: {
    ...mapActions({
      _acquireData: 'digitalKeyDetails/acquireDetails',
      _editData: 'digitalKeyDetails/editDetails',
    }),
    ...mapMutations({
      _setEdit: 'digitalKeyDetails/setEditKey',
    }),
    goBack() {
      router.push(
        `/${this.currentClient.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/keys`,
      );
    },
    getGroupName(id) {
      let screenGroup = null;
      this.currentClient.groups.map((group) => {
        if (group.uuid === id) {
          screenGroup = group;
        }
      });
      if (screenGroup) {
        return screenGroup.group_name;
      }
      return id;
    },
  },
  watch: {
    _clientIsSet() {
      if (this._clientIsSet) {
        this._acquireData(this.$route.params.id);
      }
    },
  },
  mounted() {
    if (this._clientIsSet) {
      this._acquireData(this.$route.params.id);
    }
  },
};
</script>
